<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css";
  @import url('https://fonts.googleapis.com/css?family=Ropa+Sans');
  @font-face {
    font-family: 'Zantroke';
    src: url('@/assets/zantroke-webfont.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
  }


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;

}

$red: #FF0000;
$blue: #00AA9A;
$orange: #FFA500;
$grey: #6D6F71;
$undergrey: #C2C2C2;

nav {
  display: flex;
  justify-content: flex-start;
  max-width: 1920px;
  margin: 0 auto 20px auto;
  padding: 20px;
  font-family: 'Ropa Sans', sans-serif;
  font-weight: 300;
  font-size: 18px;
  text-transform: lowercase;
  .nav-right {
    margin-left: 10px;
  }
}
.nav {
  .separador {
    color: black;
  }
  &-left {
    a {
      color: #939393;
      &:hover {
        text-decoration: none;
        color: black;        
      }
    }
    span {
      cursor: pointer;
      color: $grey;
      &.current {
        color: black;
        font-weight: 600;
        a {
          color: black;
        }
        &:hover {
          color: black;
        }
      }
      &.active, &.sub.active {
        a {
          color: $red;
        }
        color: $red;
          &:hover {
            color: $undergrey;
            cursor: default;
          }
      }
      &.sub {
          color: $undergrey;
          color: $orange;  
        &:hover {
          color: $orange;
        }
      }
      &:hover {
        color: black;
      }
    }
  }
  &-right {
    a {
      color: #898a8b;
      &:hover {
        color: black;
        text-decoration: none;
      }
    }
  }
}

.VueCarousel {
  width: 100%;
  margin: 0 auto;
  &-slide {
  }
  &-navigation-button, input[type=button] {
      all: unset;
      -webkit-appearance: none;  /* Disable iOS default styles */
      -moz-appearance: none;
      appearance: none;
      top: calc(75%) !important;
      transform: none !important;
      height: 0;
      font-size: 40px;
      background-color: rgba(255,255,255,0.0) !important;
      border-radius: 20px;
      left: 35px !important;
      &.VueCarousel-navigation-next {
        left: auto !important;
        padding: 5px 8px !important;
        right: 35px;
      }
      &:focus {
        outline: none !important;
      }      
  }
}

.open-menu {
  display: block;
}
@media (max-width: 768px) {
  .open-menu {
    display: block;
    padding: 35px;
    &>div {
      flex-direction: column;
      display: flex;
      span {
        width: 30px;
        height: 4px;
        margin-bottom: 4px;
        background: black;
      }
    }
  }
}

@media (max-width: 768px) {
  .VueCarousel {
    &-navigation {
      &-button {
        -webkit-appearance: none;  /* Disable iOS default styles */
        -moz-appearance: none;
        appearance: none;
        height: 30px;
        width: 30px;
        background-size: 100%;
      }
      &-prev {
        left: 3px !important;
      }
      &-next {
        right: 3px !important;
      }
    }
  }
  
  
}

.nav-mobile {
  display: none;
}
@media (max-width: 768px) {
  nav {
    display: none;
    padding: 8vw;
    background: black;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 1000;
    font-family: 'Zantroke', Georgia, serif;
    &.active {
      display: block;
    }
    .nav-left, .nav-right {
      a, .current, .separador {
        display: none;
      }
      .sub {
        display: none;
        color: #6C6D70;
        font-size: 11vw;
        line-height: 1.1;
        &.active, &:hover {
          color: white !important;
        }
      }
    }
    .extra {
      display: none;
    }

  }
  .nav-mobile {
    display: block;
    height: 100%;
    position: relative;
    a, span {
      font-size: 11vw;
      line-height: 1.1;
      display: block;
      color: #FF5554;
      text-decoration: none !important;
    }
    .current {
      color: white;
    }
    .cont {
      color: #C5C6C8;      
    }
    .sub {
      color: #6C6D70;
      font-size: 11vw;
      line-height: 1.1;
      &.active, &:hover {
        // color: white !important;
      }
    }
    .conts {
      position: absolute;
      bottom: 0vw;
      left: 0vw;
      color: white;
      font-size: 4vw;
    }
  }
}

</style>
